import React, { useState, useEffect } from "react";
import { Modal,  Form, Button } from "antd";

import TextInput from "../../ReusableInputs/TextInput";
import SelectOption from "../../ReusableInputs/SelectOption";
import CustomDatePicker from "../../ReusableInputs/CustomDatePicker";
import { PromoCode } from "../../../@types/promo-code";

export const DiscountModalDashBoard: React.FC<{
  isProcessing: boolean;
  code: string;
  code_type: string;
  code_value: any;
  counter: string;
  is_used?: boolean;
  isUpdating?: boolean;
  expired_date?: any;
  promo_code: string;
  used_count: string;
  max_count: string;
  isDiscountModal: boolean;
  setCodeType: (value: any) => void;
  setMaxCount: (value: string) => void;
  setIsusedCount: (value: string) => void;
  setCodeValue: (value: any) => void;
  setCounter: (value: string) => void;
  setExpiredDate: (value: string) => void;
  setPromoCode: (value: string) => void;
  handleSubmitCode: (value: PromoCode) => void;
  handleSaveEdit: (value: PromoCode) => void;
  handleOpenDiscountModal: () => void;
  onClose: () => void;
}> = ({
  isDiscountModal,
  setPromoCode,
  promo_code,
  onClose,
  handleOpenDiscountModal,
  isProcessing,
  handleSubmitCode,
  code_type,
  code_value,
  counter,
  expired_date,
  isUpdating,
  handleSaveEdit,
  setCodeType,
  setCounter,
  setExpiredDate,
  setCodeValue,
  max_count,
  used_count,
  setMaxCount,
  setIsusedCount,
}) => {
  const [form] = Form.useForm();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

  useEffect(() => {
    if (code_type === "percentage") {
      const numericValue = parseFloat(code_value);
      if (numericValue < 1 || numericValue > 100 || isNaN(numericValue)) {
        setErrorMessage("Percentage value must be between 1 and 100");
        setIsButtonDisabled(true);
      } else {
        setErrorMessage(null);
        setIsButtonDisabled(false);
      }
    } else {
      setErrorMessage(null);
      setIsButtonDisabled(false);
    }
  }, [code_value, code_type]);

  return (
    <Modal
      title="Discount"
      open={isDiscountModal}
      onCancel={onClose}
      width={700}
      bodyStyle={{ maxHeight: "550px", overflowY: "auto" }}
      footer={null}>
      <Form
        form={form}
        onFinish={() => {
          if (isUpdating) {
            handleSaveEdit({
              code_type,
              code_value,
              used_count,
              max_count,
              expired_date,
              code: promo_code,
            });
          } else {
            handleSubmitCode({
              code: promo_code,
              code_type,
              code_value,
              used_count,
              max_count,
              expired_date,
            });
          }
        }}>
        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <SelectOption
              title="Promo Code Type"
              value={code_type}
              setValue={setCodeType}
              placeholder="Select Promo Code Type"
              options={[
                { value: "percentage", label: "Percentage" },
                { value: "decimal", label: "Fixed Amount" },
              ]}
              name="code_type"
              tooltipText="Select the type of promo code to apply."
            />
          </div>

          <div className="w-full p-2">
            <Form.Item
              name="code_value"
              rules={[
                {
                  required: true,
                  message: "Please enter the code value",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const codeType = getFieldValue("code_type");

                 
                    const numericValue = parseFloat(value);

                    if (codeType === "percentage") {
                      if (
                        !isNaN(numericValue) &&
                        numericValue >= 1 &&
                        numericValue <= 100
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Percentage value must be between 1 and 100")
                      );
                    }

                    return Promise.resolve(); 
                  },
                }),
              ]}>
              <TextInput
                title="Code Value"
                placeholder="Enter Code Value"
                inputValue={code_value}
                setInputValue={(value: string) => setCodeValue(value)}
                name="code_value"
                tooltipText="Enter the value for the promo code."
                
              />
            </Form.Item>
            {errorMessage && (
              <div className="text-red-500 text-sm mt-[-30px]">{errorMessage}</div>
            )}
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
             
              title="Maximum Limit"
              placeholder="Enter the maximum limit"
              inputValue={max_count}
              setInputValue={setMaxCount}
              tooltipText="Set the maximum usage limit for this promo code."
            />
          </div>
          <div className="w-full p-2">
            <CustomDatePicker
              expired_date={expired_date}
              setExpiredDate={setExpiredDate}
            />
          </div>
        </section>

        <Button
          htmlType="submit"
          className="w-full mt-[7px] py-3 px-6 border border-gray-400 rounded-lg shadow text-white bg-teal-800 font-semibold"
          loading={isProcessing}
          disabled={isButtonDisabled}>
          {isProcessing
            ? isUpdating
              ? "Updating..."
              : "Adding..."
            : isUpdating
            ? "Update Promo Code"
            : "Add Promo Code"}
        </Button>
      </Form>
    </Modal>
  );
};
